export const environment = {
  production: true,
  hmr: false,
  apiServer: {
    domain: 'api-brain.andi.it',
    protocol: 'https',
    wsProtocol: 'ws',
    port: 443
  },
  nppApiServer: {
    domain: 'andi-api.dlsprivacy.it',
    protocol: 'https',
    port: 443
  },

  googleAnalyticsKey: 'UA-137741872-1',

  appUserAgent: 'BrainApp',

  corsoAndiProgetti: 2441,

  apiCorsi: 'https://corsi.andi.it/api/corsi/',
  api8108: 'https://corsi.andi.it/api/8108/',
  apiGdpr: 'https://corsi.andi.it/api/gdpr/',
  corsiBackdoorEnabled: false,
  corsiBackdoor: null,

  apiPaypalTest: 'AWvKBdJho4B7hpMtqgPLH4H2hXtH7MAobfc_Zd5uW_HFMFbIJqOFTV76-tO6ooGQtQhfkE7yphMku1bd',
  apiPaypalProd: 'AcfGYOMaob1NPMzxGVNtzPNQc2MxC3ysMpm5uHajEeLG8rHxX4uyPT7TY3YciX3lLzDhWMuPMTFN_HIV',

  baseUrlAnagrafica: 'https://brainanagrafica.andi.it/#/',
  baseUrlServizi: 'https://brainservizi.andi.it/#/',
  baseUrlSocial: 'https://brainsocial.andi.it/#/',

  urlPreLoginAnagrafica: 'https://brainanagrafica.andi.it/#/pre-login',
  urlPreLoginServizi: 'https://brainservizi.andi.it/#/pre-login',

  urlPreLoginSocial: 'https://brainsocial.andi.it/#/pre-login',

  linkContratto:
    'https://s3-eu-west-1.amazonaws.com/assets.brainservizi.public/documents/fatturaelettronica/condizioni.pdf',
  linkPrivacy:
    'https://s3-eu-west-1.amazonaws.com/assets.brainservizi.public/documents/fatturaelettronica/informativa_fattura.pdf',

  codice_destinatario: 'C3UCNRB',

  regexPsw: `^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-_@,!"£$%&\/\-()=?'^#<>:;§\*\[\]\.\\\|])[\w@,!"£$%&\/\-()=?'^#<>:;§\*\[\]\.\\\|]{6,}$`,

  FBCONFIG: {
    apiKey: 'AIzaSyCBtRyxBwYOxqOqKbxEjiwPPxb_78N0a2U',
    authDomain: 'brain-92d52.firebaseapp.com',
    databaseURL: 'https://brain-92d52.firebaseio.com',
    projectId: 'brain-92d52',
    storageBucket: 'brain-92d52.appspot.com',
    messagingSenderId: '930126862474'
  },
  apiPaypal: 'sb',

  checkDatiAnagrafici: true,

  apiPaypalCongresso: 'Aeb4U6PdtEqHBYpmwzyaHRB8-rsBYLdojSEg5-XJwDQfY3p14Kh9J-tC_4UC6JJnazxNByY0iwIyz7Ub'
};
